import { Component } from '@angular/core';
import { ViewController, NavParams, Events } from 'ionic-angular';
import { UEData } from '../../providers/ue-data';
import { UserData } from '../../providers/user-data';
import moment from 'moment';
@Component({
  templateUrl: 'ue-filters.html'
})

export class UEFiltersPage {
    
constructor(
              public events:Events
            , public viewCtrl: ViewController
            ,public navParams:NavParams
            ,public ueData:UEData
            ,public userData: UserData
            ) {
    
}
searchUE(search) {
    let searchQuery = "";
    let startdate = moment();
    switch (search) {
        case 'today':
            searchQuery = moment().format("YYYY-MM-DD");
            break;
        case 'yesterday':
            startdate = startdate.subtract(1, "days");
            searchQuery = startdate.format("YYYY-MM-DD"); 
            break;
        case 'daybeforeyesterday':
            startdate = startdate.subtract(2, "days");
            searchQuery = startdate.format("YYYY-MM-DD"); 
            break;
            
        case 'month':
            searchQuery = moment().format("YYYY-MM");
            break;
        default:
        searchQuery = search;

    }    
    this.ueData.searchQuery = searchQuery;
    this.events.publish('ue:search');    
    this.viewCtrl.dismiss();
  }
}


// WEBPACK FOOTER //
// ./src/pages/ue-list/ue-filters.ts